export default {
	data() {
		return {
			geocodeOptions: {
				countries: 'nl,be,de',
				types: 'place,postcode',
				flyTo: false,
				elementId: 'geocoder',
				language: 'nl-NL',
				placeholder: 'zoeken',
				marker: false
			},
			localFeatures: [],
			fitboundsPadding: 50,
			defaultZoom: 6,
			maxZoom: 10,
			search: {
				location: '',
				geometry: {}
			}
		};
	},
	mounted() {
		if (!window.MapboxGeocoder) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = false;
			script.src =
				'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.5.1/mapbox-gl-geocoder.min.js';
			document.body.appendChild(script);

			script.onload = () => {};
		}
	},
	methods: {
		addGeocoder(map) {
			this.geocodeOptions.mapboxgl = window.mapboxgl;
			this.localFeatures = {
				features: this.localdestinations_with_location.map(location => {
					return {
						type: 'Feature',
						properties: {
							title: location.name,
							description: ''
						},
						geometry: location.geography.location
					};
				})
			};
			this.loadGeocoder(
				map,
				{ accessToken: window.mapboxgl.accessToken },
				window.MapboxGeocoder
			);
		},
		geoCoderOnResult(map, result) {
			if (result.bbox) {
				map.jumpTo(
					map.cameraForBounds(result.bbox, {
						padding: this.fitboundsPadding,
						maxZoom: this.maxZoom
					})
				);
			} else {
				map.setCenter(result.center);
				map.setZoom(this.maxZoom);
			}

			this.search.geometry = {
				lng: result.center[0],
				lat: result.center[1]
			};
			this.search.location = result.properties.title;
		},
		geoCoderOnClear(map) {
			map.setCenter(this.center);
			map.setZoom(this.defaultZoom);

			this.search.geometry = {};
			this.search.location = '';
		},
		loadGeocoder(map, options, MapboxGeocoder) {
			this.geocodeOptions = { ...this.geocodeOptions, ...options };
			this.geocodeOptions.localGeocoder = this.forwardGeocoder;

			const geocoder = new MapboxGeocoder(this.geocodeOptions)
				.on('result', response => {
					if (this.geocodeOptions.flyTo === false) {
						if (typeof this.geoCoderOnResult === 'function') {
							this.geoCoderOnResult(map, response.result);
						}
					}
				})
				.on('clear', () => {
					if (typeof this.geoCoderOnClear === 'function') {
						this.geoCoderOnClear(map);
					}
				});

			map.addControl(geocoder);
		},
		forwardGeocoder(query) {
			if (!this.localFeatures.features) return [];

			const matchingFeatures = [];
			for (let i = 0; i < this.localFeatures.features.length; i++) {
				const feature = this.localFeatures.features[i];

				if (
					feature.properties.title.toLowerCase().includes(query.toLowerCase())
				) {
					feature.place_name = feature.properties.title;
					feature.center = feature.geometry.coordinates;
					feature.place_type = ['poi'];
					matchingFeatures.push(feature);
				}
			}
			return matchingFeatures;
		}
	}
};
